import { Row, Col, Container } from 'react-bootstrap';

const CertificateTable = ({ data, size }) => {
    // Function to format date from YYYY-MM-DD to DD-MM-YYYY
    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return dateString; // Return original if invalid
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    if (!data) {
        return (
            <Container>
                <Row style={{ paddingLeft: 10, paddingBottom: 15 }}>
                    <Col>
                        <Row style={{ paddingTop: 10, paddingBottom: 10 }}>
                            <Col className='text-center'>No certificate data available</Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        );
    }

    return (
        <Container>
            <Row style={{ paddingLeft: 10, paddingBottom: 15 }}>
                <Col>
                    <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                            Title of Position/Role:
                        </Col>
                        <Col>{data?.field_tr_tbl_d_title || ''}</Col>
                    </Row>
                    <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                            Trainee Name:
                        </Col>
                        <Col>{data?.field_tr_tbl_d_trainee || ''}</Col>
                    </Row>
                    <Row style={{ paddingTop: 20, paddingBottom: 10 }}>
                        <Col>
                            <hr style={{ margin: 0, borderTop: '2px solid #dee2e6' }} />
                        </Col>
                    </Row>
                    <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                            Start Period (Complete):
                        </Col>
                        <Col>{formatDate(data?.field_tr_tbl_d_sta_per_complete)}</Col>
                    </Row>
                    <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                            End Period (Complete):
                        </Col>
                        <Col>{formatDate(data?.field_tr_tbl_d_end_per_complete)}</Col>
                    </Row>
                    <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                            Start Period (Physical):
                        </Col>
                        <Col>{formatDate(data?.field_tr_tbl_d_sta_per_physical)}</Col>
                    </Row>
                    <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                            End Period (Physical):
                        </Col>
                        <Col>{formatDate(data?.field_tr_tbl_d_end_per_physical)}</Col>
                    </Row>
                    <Row style={{ paddingTop: 20, paddingBottom: 10 }}>
                        <Col>
                            <hr style={{ margin: 0, borderTop: '2px solid #dee2e6' }} />
                        </Col>
                    </Row>
                    <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                            Receiving Organisation:
                        </Col>
                        <Col>{data?.field_tr_tbl_d_rec_org || ''}</Col>
                    </Row>
                    <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                            Organisation Address:
                        </Col>
                        <Col>{data?.field_tr_tbl_d_rec_org_add || ''}</Col>
                    </Row>
                    <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                            Organisation Sector:
                        </Col>
                        <Col>{data?.field_tr_tbl_d_rec_org_sec || ''}</Col>
                    </Row>
                    <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                            Organisation Website:
                        </Col>
                        <Col>{data?.field_tr_tbl_d_rec_org_web || ''}</Col>
                    </Row>
                    <Row style={{ paddingTop: 20, paddingBottom: 10 }}>
                        <Col>
                            <hr style={{ margin: 0, borderTop: '2px solid #dee2e6' }} />
                        </Col>
                    </Row>
                    <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                            Programme Description:
                        </Col>
                        <Col style={{ whiteSpace: 'pre-wrap' }}>{data?.field_tr_tbl_d_program || ''}</Col>
                    </Row>
                    <Row style={{ paddingTop: 20, paddingBottom: 10 }}>
                        <Col>
                            <hr style={{ margin: 0, borderTop: '2px solid #dee2e6' }} />
                        </Col>
                    </Row>
                    <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                            Knowledge, Skills & Competences:
                        </Col>
                        <Col style={{ whiteSpace: 'pre-wrap' }}>{data?.field_tr_tbl_d_knowledge || ''}</Col>
                    </Row>
                    <Row style={{ paddingTop: 20, paddingBottom: 10 }}>
                        <Col>
                            <hr style={{ margin: 0, borderTop: '2px solid #dee2e6' }} />
                        </Col>
                    </Row>
                    <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                            Evaluation:
                        </Col>
                        <Col style={{ whiteSpace: 'pre-wrap' }}>{data?.field_tr_tbl_d_evaluation || ''}</Col>
                    </Row>
                </Col>
            </Row>
        </Container>
    );
};

export default CertificateTable;